// extracted by mini-css-extract-plugin
export default {"__label":"Options___label__WoDpV","row":"Options_row__riRzU","row__button":"Options_row__button__cW2CO"};